import { Loading } from 'element-ui'


// loading框设置局部刷新，且所有请求完成后关闭loading框
let loading

function startLoading() {
    loading = Loading.service({
        fullscreen: true,
        // background: 'rgba(0, 0, 0, 0)',
        text: '努力加载中...',
        background: 'rgba(255, 255, 255, 0.6)',
        target: document.querySelector('.loading-area') // 设置加载动画区域
    })
}

function endLoading() {
    loading.close()
}
// 声明一个对象用于存储请求个数
let needLoadingRequestCount = 0

function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading()
    }
    needLoadingRequestCount++
}

function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        endLoading()
    }
}


var prefix = ''
const api = {
    request(url, data, cb, errCb) {
        url += prefix
        axios.post(url, data).then((res) => {
            if (res.data.status == 0) {
                _g.toast('info', res.data.message)
            } else {
                cb(res.data)
            }
        }).catch((res) => {
            if (res.response) {
                if (res.response.status == 500) {
                    _g.toast('info', '服务器错误!')
                    return;
                } else if (res.response.status == 400) {
                    if (res.response.data.errCode == "E_0300101" || res.response.data.errCode == "E_0300112") {
                        _g.toast('info', res.response.data.errMsg)
                        Lockr.flush()
                        if (router.currentRoute.name != 'login') {
                            router.push({path: '/login', query: {redirect: router.currentRoute.fullPath}})
                        }
                        return;
                    } else {
                        _g.toast('error', res.response.data.errMsg)
                        errCb(res.response)
                        return;
                    }
                }
            }
        })
    },
    requestQuiet(url, data, cb, errCb) {
        showFullScreenLoading()
        url += prefix
        axios.post(url, data).then((res) => {
            tryHideFullScreenLoading()
            if (res.data.status == 0) {
                _g.toast('info', res.data.message)
            } else {
                cb(res.data)
            }
        }).catch((res) => {
            tryHideFullScreenLoading()
            if (res.response) {
                if (res.response.status == 500) {
                    _g.toast('info', '服务器错误!')
                    return;
                } else if (res.response.status == 400) {
                    if (res.response.data.errCode == "E_0300101" || res.response.data.errCode == "E_0300112" ) {
                        console.log(res)
                        _g.toast('info', res.response.data.errMsg)
                        Lockr.flush()
                        if (router.currentRoute.name != 'login') {
                            router.push({ path: '/login', query: { redirect: router.currentRoute.fullPath } })
                        }
                        return;
                    } else {
                        _g.toast('error', res.response.data.errMsg)
                        errCb(res.response)
                        return;
                    }
                }
            }
        })
    },
}

export default api